'use es6';

import events from '../../events.yaml';
import { getParsedTrackingParams } from 'ecosystem-marketplace-core/utils/trackingParams';

const getSessionUrlParams = () => {
  const trackingParams = getParsedTrackingParams();
  return Object.keys(trackingParams).reduce((final, key) => {
    const value = trackingParams[key];
    final.push(`${key}=${value}`);
    return final;
  }, []);
};

export const getTrackerConfig = (inAppOrPublic = 'in-app') => ({
  events,
  properties: {
    namespace: 'marketplace',
    type: 'integration',
    inAppOrPublic,
    sessionUrlParams: getSessionUrlParams()
  },
  lastKnownEventProperties: ['screen']
});
let tracker;
let beforeUnloadTracker;
export const getUsageTracker = () => tracker;
export const getBeforeUnloadUsageTracker = () => beforeUnloadTracker;
export const setUsageTracker = _tracker => {
  tracker = _tracker;
  beforeUnloadTracker = _tracker.clone({
    isBeforeUnload: true
  });
};